import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  stroke: "none",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.4",
  d: "M8.9375 0C4.00146 0 0 4.00146 0 8.9375C0 13.8735 4.00146 17.875 8.9375 17.875C13.8735 17.875 17.875 13.8735 17.875 8.9375C17.875 4.00146 13.8735 0 8.9375 0ZM8.9375 14.4375C5.90477 14.4375 3.4375 11.9701 3.4375 8.9375C3.4375 5.90477 5.90477 3.4375 8.9375 3.4375C11.9702 3.4375 14.4375 5.90477 14.4375 8.9375C14.4375 11.9701 11.9702 14.4375 8.9375 14.4375Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M21.6957 20.7254L20.7234 21.6977C20.3207 22.1004 19.6678 22.1004 19.265 21.6977L13.9219 16.3546C14.8805 15.7088 15.7068 14.8824 16.3526 13.9238L21.6957 19.267C22.0984 19.6697 22.0984 20.3227 21.6957 20.7254Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const UikitSearchIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  UikitSearchIcon as default
};
//# sourceMappingURL=SearchIcon.vue.es.js.map
